import React from "react";
import { useTranslation } from "react-i18next";

export const InternalInformationManagement = () => {
    const {t} = useTranslation()
    return(
        <>
        <div className="contentBox">
            <div>
                <h3>
                    <span>{t("invest_internal_information_title")}</span>
                </h3>
                <ul>
                    <li>
                        <h4>{t("invest_internal_information_main_1")}</h4>
                        <div>
                            <span>{t("invest_internal_information_sub_1")}</span>
                            <p>
                                {t("invest_internal_information_content_1")}
                            </p>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_2")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_2")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_3")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_4")}
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_5")}
                                </li>
                                <li>
                                    <span>5.</span>
                                    {t("invest_internal_information_content_5_1")}
                                </li>
                                <li>
                                    <span>6.</span>
                                    {t("invest_internal_information_content_5_2")}
                                </li>
                                <li>
                                    <span>7.</span>
                                    {t("invest_internal_information_content_5_3")}
                                </li>
                                <li>
                                    <span>8.</span>
                                    {t("invest_internal_information_content_5_4")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_3")}</span>
                            <p>{t("invest_internal_information_content_6")}</p>
                        </div>
                    </li>
                    <li>
                        <h4>{t("invest_internal_information_main_2")}</h4>
                        <div>
                            <span>{t("invest_internal_information_sub_4")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_7")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_8")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_8_1")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_5")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_9")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_10")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_11")}
                                    <ol className="subNumbList">
                                        <li>
                                            <span>1)</span>
                                            {t("invest_internal_information_content_12")}
                                        </li>
                                        <li>
                                            <span>2)</span>
                                            {t("invest_internal_information_content_13")}
                                        </li>
                                        <li>
                                            <span>3)</span>
                                            {t("invest_internal_information_content_14")}
                                        </li>
                                        <li>
                                            <span>4)</span>
                                            {t("invest_internal_information_content_15")}
                                        </li>
                                        <li>
                                            <span>5)</span>
                                            {t("invest_internal_information_content_16")}
                                        </li>
                                        <li>
                                            <span>6)</span>
                                            {t("invest_internal_information_content_17")}
                                        </li>
                                        <li>
                                            <span>7)</span>
                                            {t("invest_internal_information_content_18")}
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_20")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_6")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_21")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_21_1")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_21_2")}
                                    <ol className="subNumbList">
                                        <li>
                                            <span>1)</span>
                                            {t("invest_internal_information_content_21_3")}
                                        </li>
                                        <li>
                                            <span>2)</span>
                                            {t("invest_internal_information_content_21_5")}
                                        </li>
                                        <li>
                                            <span>3)</span>
                                            {t("invest_internal_information_content_21_6")}
                                        </li>
                                        <li>
                                            <span>4)</span>
                                            {t("invest_internal_information_content_21_7")}
                                        </li>
                                        <li>
                                            <span>5)</span>
                                            {t("invest_internal_information_content_21_4")}
                                        </li>
                                        <li>
                                            <span>6)</span>
                                            {t("invest_internal_information_content_23")}
                                        </li>
                                        <li>
                                            <span>7)</span>
                                            {t("invest_internal_information_content_24")}
                                        </li>
                                        <li>
                                            <span>8)</span>
                                            {t("invest_internal_information_content_25")}
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_26")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_7")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_28")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_29")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_30")}
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_31")}
                                </li>
                                <li>
                                    <span>5.</span>
                                    {t("invest_internal_information_content_32")}
                                </li>
                                <li>
                                    <span>6.</span>
                                    {t("invest_internal_information_content_33")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_8")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_34")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_35")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_36")}
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_37")}
                                </li>
                                <li>
                                    <span>5.</span>
                                    {t("invest_internal_information_content_38")}
                                </li>
                            </ol>
                        </div>
                    </li>
                    <li>
                        <h4>{t("invest_internal_information_main_3")}</h4>
                        <div>
                            <span>{t("invest_internal_information_sub_9")}</span>
                            <p>{t("invest_internal_information_content_40")}</p>
                            <ol className="subNumbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_41")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_42")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_43")}
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_44")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_10")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_45")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_46")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_47")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_11")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_48")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_53")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_12")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_54")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_55")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_56")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_13")}</span>
                            <p>{t("invest_internal_information_content_57")}</p>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_14")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_58")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_59")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_60")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_15")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_61")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_62")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_63")}
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_64")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_16")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_65")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_66")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_67")}
                                </li>
                            </ol>
                        </div>
                        <div>
                            <span>{t("invest_internal_information_sub_17")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_68")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_69")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_70")}
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_71")}
                                </li>
                            </ol>
                        </div>

                        <div>
                            <span>{t("invest_internal_information_sub_18")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_72")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_73")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_74")}
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_75")}
                                </li>
                            </ol>
                        </div>
                    </li>
                    <li>
                        <h4>{t("invest_internal_information_main_4")}</h4>
                        <div>
                            <span>{t("invest_internal_information_sub_19")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_77")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_78")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_79")}
                                    <ol className="subNumbList">
                                        <li>
                                            <span>1)</span>
                                            {t("invest_internal_information_content_79_1")}
                                        </li>
                                        <li>
                                            <span>2)</span>
                                            {t("invest_internal_information_content_79_2")}
                                        </li>
                                        <li>
                                            <span>3)</span>
                                            {t("invest_internal_information_content_79_3")}
                                        </li>
                                        <li>
                                            <span>4)</span>
                                            {t("invest_internal_information_content_79_4")}
                                        </li>
                                        <li>
                                            <span>5)</span>
                                            {t("invest_internal_information_content_79_5")}
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_80")}
                                </li>
                                <li>
                                    <span>5.</span>
                                    {t("invest_internal_information_content_81")}
                                </li>
                            </ol>
                        </div>

                        <div>
                            <span>{t("invest_internal_information_sub_20")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_82")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_83")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_84")}
                                </li>
                            </ol>
                        </div>

                        <div>
                            <span>{t("invest_internal_information_sub_21")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_85")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_86")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_87")}
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_88")}
                                </li>
                            </ol>
                        </div>
                    </li>
                    <li>
                        <h4>{t("invest_internal_information_main_5")}</h4>
                        <div>
                            <span>{t("invest_internal_information_sub_22")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_89")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_90")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_91")}
                                </li>
                                <li>
                                    <span>4.</span>
                                    {t("invest_internal_information_content_92")}
                                </li>
                                <li>
                                    <span>5.</span>
                                    {t("invest_internal_information_content_93")}
                                </li>
                            </ol>
                        </div>

                        <div>
                            <span>{t("invest_internal_information_sub_23")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_94")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_95")}
                                </li>
                            </ol>
                        </div>

                        <div>
                            <span>{t("invest_internal_information_sub_24")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_96")}
                                </li>
                                <li>
                                    <span>2.</span>
                                    {t("invest_internal_information_content_97")}
                                </li>
                                <li>
                                    <span>3.</span>
                                    {t("invest_internal_information_content_98")}
                                </li>
                            </ol>
                        </div>
                    </li>

                    <li>
                        <h4>{t("invest_internal_information_main_6")}</h4>
                        <div>
                            <span>{t("invest_internal_information_sub_25")}</span>
                            <ol className="numbList">
                                <li>
                                    <span>1.</span>
                                    {t("invest_internal_information_content_99")}
                                </li>
                            </ol>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        </>
    )
}
